// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_models-modal.scss';


// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}


$(function() {
    
    // -------------------------------------
    // Models Modla - PDP
    // -------------------------------------
    $(".carousel--models-pdp").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("models-pdp-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.modal-models').find(".swiper-button-prev").addClass("models-pdp-btn-prev-" + index);
        $this.parents('.modal-models').find(".swiper-button-next").addClass("models-pdp-btn-next-" + index);

        // Generate unique btn classes for slider swiper
        $this.parents('.modal-models').find(".swiper-scrollbar").addClass("models-pdp-swiper-scrollbar-" + index);


        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".models-pdp-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.7,
            spaceBetween: 22,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: false, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },

             // // Navigation arrows
            navigation: {
                nextEl: ".models-pdp-btn-next-" + index,
                prevEl: ".models-pdp-btn-prev-" + index
            },

            // // Navigation scrollbar
            scrollbar: {
                el: ".models-pdp-swiper-scrollbar-" + index,
                draggable: true,
            }
        });
    });
    
    
    // Closes modal when close buttons are clicked
    $('.icon-close-models').on( "click", () => {
        const modal = $('.modal-models');
        //Trigger only if Desktop
        if ($(window).width() < 1024) {
            return;
        }  
        modal.removeClass('modal--open');
        
        $('body').removeClass('noscroll');
        $('.shopify-section--header').removeClass('sendback');
        
        // Broadcast a notification that a modal closed
        $(window).trigger('close.modal', modal);
    });
});